/**
 * Expand mode for {@link AccordionMenu}
 * @public
 */
export const AccordionMenuExpandModes = {
    single: "single",
    multi: "multi"
};
//# sourceMappingURL=accordion-menu.options.js.map